<script setup lang="ts">
interface Props {
  modelValue: boolean
}

defineProps<Props>()
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

function toggle(event: Event) {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.checked)
}
</script>

<template>
  <section class="bg-gray-50 rounded-2xl p-6">
    <div class="flex items-start space-x-3">
      <input
        type="checkbox"
        id="terms-checkbox"
        :checked="modelValue"
        @change="toggle"
        class="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mt-1"
      />
      <label for="terms-checkbox" class="text-sm text-gray-700">
        I agree to the
        <a href="/terms-of-service" class="text-blue-600 hover:text-blue-700 font-medium">Terms and Conditions</a>
        and
        <a href="/privacy-policy" class="text-blue-600 hover:text-blue-700 font-medium">Privacy Policy</a>.
        I understand that my subscription will automatically renew each month unless cancelled.
      </label>
    </div>
  </section>
</template>
